import { useChartDataContext } from "src/pages/analytics/state";
import { RefreshIcon } from "@hightouch/htui";
import {
  PermissionedButton,
  PermissionedIconButton,
} from "src/components/permission";
import { runChartPermission } from "src/pages/analytics/permissions";

export const RefreshControl = ({
  parentModelId,
}: {
  parentModelId?: number | null;
}) => {
  const { isPolling, runQuery, staleQuery } = useChartDataContext();

  const sharedRefreshButtonProps = {
    isDisabled: isPolling,
    "aria-label": "Refresh chart",
    icon: RefreshIcon,
  };

  if (staleQuery && !isPolling) {
    return (
      <PermissionedButton
        permission={runChartPermission(parentModelId?.toString())}
        variant="primary"
        onClick={runQuery}
        icon={RefreshIcon}
      >
        Refresh
      </PermissionedButton>
    );
  }

  return (
    <PermissionedIconButton
      {...sharedRefreshButtonProps}
      permission={runChartPermission(parentModelId?.toString())}
      variant="secondary"
      onClick={runQuery}
    />
  );
};
